import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CondominiumFormComponent } from '../../shared/condominium-form/condominium-form.component';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.sass'],
    standalone: false
})
export class RegistrationComponent implements OnInit {
  @ViewChild(CondominiumFormComponent) formComp?: CondominiumFormComponent;

  condominiumId?: number;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const idParam = this.route.parent.snapshot.paramMap.get('id');
    if (idParam && !isNaN(Number(idParam))) {
      this.condominiumId = +idParam;
    }
  }

  onSave(): void {
    this.formComp?.save();
  }

  onCancel(): void {
    this.formComp?.reload();
  }
}


